import { MESSAGE } from './message'

export type RuleType =
  | 'string'
  | 'number'
  | 'boolean'
  | 'method'
  | 'regexp'
  | 'integer'
  | 'float'
  | 'object'
  | 'enum'
  | 'date'
  | 'url'
  | 'hex'
  | 'email'

export const VALIDATE = {
  required: { required: true, message: MESSAGE.REQUIRED_FIELD },
  whitespace: { whitespace: true, message: MESSAGE.REQUIRED_FIELD },
  code: {
    pattern: /^[a-zA-Z_]+$/g,
    message: MESSAGE.INVALID_CODE
  },
  password: {
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_-])[A-Za-z\d!@#$%^&*()_-]{8,50}$/g,
    message: MESSAGE.INVALID_PASSWORD
  },
  email: {
    pattern:
      /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g,
    message: MESSAGE.INVALID_EMAIL
  },
  numberMax5: {
    type: 'number' as RuleType,
    max: 99999,
    message: MESSAGE.MAX_5
  },
  numberMin7: {
    type: 'number' as RuleType,
    min: 7,
    message: MESSAGE.MAX_7_BACKUP
  },
  numberMax15: {
    type: 'number' as RuleType,
    max: 999999999999999,
    message: MESSAGE.MAX_15
  },
  numberMax31: {
    type: 'number' as RuleType,
    max: 31,
    message: MESSAGE.MAX_31_DAYS
  },
  max5: {
    max: 5,
    message: MESSAGE.MAX_5
  },
  max15: {
    max: 15,
    message: MESSAGE.MAX_15
  },
  max50: {
    max: 50,
    message: MESSAGE.MAX_50
  },
  max255: {
    max: 255,
    message: MESSAGE.MAX_255
  },
  max100: {
    max: 100,
    message: MESSAGE.MAX_100
  },
  max500: {
    max: 500,
    message: MESSAGE.MAX_500
  },
  max1000: {
    max: 1000,
    message: MESSAGE.MAX_1000
  },
  max2000: {
    max: 2000,
    message: MESSAGE.MAX_2000
  },
  max5000: {
    max: 5000,
    message: MESSAGE.MAX_5000
  },
  max6000: {
    max: 6000,
    message: MESSAGE.MAX_6000
  },
  max60000: {
    max: 60000,
    message: MESSAGE.MAX_60000
  },
  number: {
    pattern: /^[0-9]+$/,
    message: MESSAGE.INVALID_NATURAL_NUMBER
  },
  numberDecimal: {
    pattern: /^\d+(\.\d+)?$/,
    message: MESSAGE.INVALID_DECIMAL_NUMBER
  }
}
